import {
  MRT_ColumnDef,
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table"
import { useAppSelector } from "../../../redux/hooks"
import { Box } from "@mui/material"
import { defaultTableProps } from "../ResourceBudgetTable/constants"
import SortIcon from "@mui/icons-material/Sort"
import { useEffect } from "react"
import { setHuddleSummaryTodayRows } from "../../../redux/slices/huddleSlice"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { assignTableId } from "../../../../helper/utils"

type tableProps = {
  columns: MRT_ColumnDef<any>[]
  data: {}[]
  enableEditing?: boolean
  blurHandler?: any
  flex?: any
}

export const DailyProductionGoalTable = (props: tableProps) => {
  const dispatch = useDispatch()

  const { columns, data, enableEditing, blurHandler, flex } = props
  const loading = useAppSelector((state) => state.app.loading)

  const maevaSelectedPracticesNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedPracticesNoAll
  })

  const table = useMaterialReactTable({
    ...defaultTableProps,
    columns,
    data,
    defaultColumn: {
      // maxSize: 400,
      // minSize: 80,
      size: 80, //default size is usually 180
    },
    muiTableHeadCellProps: {
      align: "center",
      sx: {
        backgroundColor: "#1A428A",
        color: "#fff",
        fontWeight: "bold",
        height: "32px",
        boxShadow: " #00000022 1.95px  0px 2.6px",
      },
    },
    enableSorting: false,
    enableMultiSort: false,
    muiTableContainerProps: {
      sx: {
        borderRadius: "none",
        height: "fit-content",
        width: "100%",
      },
    },
    icons: {
      ArrowDownwardIcon: () => <SortIcon sx={{ color: "#fff", ml: "7px" }} />,
    },
    muiTableBodyCellProps: ({ cell, table }) => {
      return {
        align: "center",
        onClick: () => table.setEditingCell(cell),
        sx: {
          height: "48px",
          boxShadow: "#00000022 1.95px 0px 2.6px",
          color: "black",
        },
      }
    },
    state: {
      isLoading: loading,
      columnVisibility: { Actions: false },
      // columnPinning: {
      //     left: ["provider_name", "provider_type"],
      // },
    },
  })

  useEffect(() => {
    dispatch(setHuddleSummaryTodayRows(table?.getPrePaginationRowModel().rows))
  }, [maevaSelectedPracticesNoAll])

  return (
    <Box
      sx={{
        // border: "1px solid red",
        display: "flex",
        flexDirection: "column",
        // flexGrow: 1,
        // position: "relative",
        height: "fit-content",
        // width: "fit-content"
      }}
    >
      <MaterialReactTable table={table} />
    </Box>
  )
}
